import { Routes } from '@angular/router';
import { ErrorLayout } from '../layouts/error-layout/layout/error-layout';
import { NotFoundComponent } from '../features/not-found/not-found';

export const ERROR_ROUTES: Routes = [
    {
        path: 'not-found',
        component: ErrorLayout,
        children: [
            { path: '', component: NotFoundComponent },
        ],
    },
    {
        path: '**',
        redirectTo: '/not-found',
    },
];
